import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InceptedApeComponent } from './incepted-ape/incepted-ape.component';
import { GrossRevenueComponent } from './gross-revenue/gross-revenue.component';
import { PiasConventionComponent } from './pias-convention/pias-convention.component';
import { MdrtStatusComponent } from './mdrt-status/mdrt-status.component';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,

    InceptedApeComponent,
    GrossRevenueComponent,
    PiasConventionComponent,
    MdrtStatusComponent
  ],
  exports: [
    InceptedApeComponent,
    GrossRevenueComponent,
    PiasConventionComponent,
    MdrtStatusComponent
  ]
})
export class DashboardComponentsModule { }
